import { z } from 'zod';
import { PRODUCT_IMAGE_ALT_TEXT_MAX_LENGTH, PRODUCT_IMAGE_FORMATS, PRODUCT_IMAGE_MAX_FILE_BYTES, PRODUCT_IMAGE_MIME_TYPES, PRODUCT_IMAGE_PROCESSING_STATUSES, PRODUCT_IMAGES_MAX_COUNT, PRODUCT_IMAGE_TITLE_MAX_LENGTH, PRODUCT_IMAGE_VARIANTS, } from '../constants/products.js';
import { idSchema, isoDateTimeSchema } from './common.js';
export const productImageFormatSchema = z.enum(PRODUCT_IMAGE_FORMATS);
export const productImageMimeTypeSchema = z.enum(PRODUCT_IMAGE_MIME_TYPES);
export const productImageVariantNameSchema = z.enum(PRODUCT_IMAGE_VARIANTS);
export const productImageProcessingStatusSchema = z.enum(PRODUCT_IMAGE_PROCESSING_STATUSES);
export const productImageVariantSchema = z.object({
    id: idSchema,
    variant: productImageVariantNameSchema,
    width: z.number().int().positive(),
    height: z.number().int().positive(),
    format: productImageFormatSchema,
    mimeType: productImageMimeTypeSchema,
    fileSize: z.number().int().positive(),
    sha256: z.string().regex(/^[a-f0-9]{64}$/u),
    createdAt: isoDateTimeSchema,
});
export const productImageSchema = z.object({
    id: idSchema,
    productId: idSchema,
    dmsAttachmentId: idSchema,
    title: z.string(),
    altText: z.string(),
    sortOrder: z.number().int().min(0),
    isPrimary: z.boolean(),
    originalName: z.string(),
    mimeType: productImageMimeTypeSchema,
    fileSize: z.number().int().positive().max(PRODUCT_IMAGE_MAX_FILE_BYTES),
    width: z.number().int().positive(),
    height: z.number().int().positive(),
    sha256: z.string().regex(/^[a-f0-9]{64}$/u),
    processingStatus: productImageProcessingStatusSchema,
    processingError: z.string().nullable(),
    variants: z.array(productImageVariantSchema),
    createdById: idSchema,
    updatedById: idSchema,
    createdAt: isoDateTimeSchema,
    updatedAt: isoDateTimeSchema,
});
export const productImageListResponseSchema = z.object({
    data: z.array(productImageSchema).max(PRODUCT_IMAGES_MAX_COUNT),
});
export const productImageUploadMetadataSchema = z.object({
    title: z.string().trim().min(1).max(PRODUCT_IMAGE_TITLE_MAX_LENGTH).optional(),
    altText: z.string().trim().min(1).max(PRODUCT_IMAGE_ALT_TEXT_MAX_LENGTH).optional(),
});
export const productImageUpdateSchema = z
    .object({
    title: z.string().trim().min(1).max(PRODUCT_IMAGE_TITLE_MAX_LENGTH).optional(),
    altText: z.string().trim().min(1).max(PRODUCT_IMAGE_ALT_TEXT_MAX_LENGTH).optional(),
})
    .refine((value) => value.title !== undefined || value.altText !== undefined, {
    message: 'Mindestens ein Feld muss aktualisiert werden.',
});
export const productImageSortSchema = z.object({
    imageIds: z.array(idSchema).min(1).max(PRODUCT_IMAGES_MAX_COUNT),
});
export const productImagePrimarySchema = z.object({
    imageId: idSchema,
});
export const productImageReplaceMetadataSchema = productImageUploadMetadataSchema;
//# sourceMappingURL=product-image.js.map